import React from 'react';
import {ContactMessage} from '../../dashboard/types';

interface MessagesTabProps {
  visibleMessages: ContactMessage[];
  messagesPage: number;
  messagesTotalPages: number;
  setMessagesPage: React.Dispatch<React.SetStateAction<number>>;
}

export const MessagesTab: React.FC<MessagesTabProps> = ({
  visibleMessages,
  messagesPage,
  messagesTotalPages,
  setMessagesPage,
}) => {
   return (
     <section className='table-card'>
       <header>
         <h2>Contact Messages</h2>
       </header>

       <div className='table-wrap'>
         <table>
           <thead>
             <tr>
               <th>Name</th>
               <th>Email</th>
               <th>Phone</th>
               <th>Message</th>
               <th>Received</th>
             </tr>
           </thead>
           <tbody>
             {visibleMessages.length === 0 ? (
               <tr>
                 <td
                   colSpan={5}
                   className='empty-row'>
                   No messages found.
                 </td>
               </tr>
             ) : (
               visibleMessages.map((entry) => (
                 <tr key={entry.id}>
                   <td>{entry.name}</td>
                   <td>{entry.email}</td>
                   <td>{entry.phone}</td>
                   <td className='message-cell'>{entry.message}</td>
                   <td>{new Date(entry.createdAt).toLocaleString()}</td>
                 </tr>
               ))
             )}
           </tbody>
         </table>
       </div>

       <div className='pager'>
         <button
           disabled={messagesPage <= 1}
           onClick={() => setMessagesPage((p) => Math.max(1, p - 1))}>
           Previous
         </button>
         <span>
           Page {messagesPage} of {messagesTotalPages}
         </span>
         <button
           disabled={messagesPage >= messagesTotalPages}
           onClick={() =>
             setMessagesPage((p) => Math.min(messagesTotalPages, p + 1))
           }>
           Next
         </button>
       </div>
     </section>
   );
};
